import { put } from 'redux-saga/effects';

import * as actions from '../actions';

import { get } from '../../utils/api';
import { handleError } from '../../utils/errors';

export default function* fetchUserSaga() {
  try {
    const response = yield get('/api/v1/user/');
    yield put(actions.fetchUserSuccess(response));
  } catch (error) {
    yield handleError(error);
    yield put(actions.fetchUserFail(error));
  }
}



// WEBPACK FOOTER //
// ./app/javascript/app/store/sagas/users.js